export default __webpack_public_path__ + "6ae06a3d3846df2bfb9e6ccc5cf41cee.png";